import React from "react";
import {
  StyledBox,
  StyledList,
  StyledTitle,
  TitleContainer,
} from "components/job/index/jobInformationRow";
import { Row, Col } from "antd";
import LabelAndValue from "./labelAndValue";

function JobContent(props) {
  const { data, status } = props;

  return (
    <StyledBox>
      <Row gutter={4}>
        <Col span={24}>
          <StyledList>
            <TitleContainer>
              <StyledTitle>Content</StyledTitle>
            </TitleContainer>
            <Row gutter={2} style={{ padding: "10px" }}>
              {data?.print_color?.map((printColor, index) => (
                <React.Fragment key={`print-color-${index}`}>
                  <Col xs={12}>
                    <LabelAndValue
                      label="Type"
                      value={printColor.type || "-"}
                      status={status}
                    />
                  </Col>
                  {printColor.selected_color.map(
                    (selectedColor, colorIndex) => (
                      <Col xs={12} key={`print-color-${colorIndex}`}>
                        <LabelAndValue
                          mt2={colorIndex > 0}
                          label={`Color ${colorIndex + 1}`}
                          value={
                            `${
                              selectedColor.type
                            } - ${selectedColor.color.toLowerCase()}` || "-"
                          }
                          status={status}
                        />
                      </Col>
                    )
                  )}
                </React.Fragment>
              ))}
            </Row>
          </StyledList>

          <StyledList $last>
            <TitleContainer>
              <StyledTitle>Paper</StyledTitle>
            </TitleContainer>
            <Row gutter={2} style={{ padding: "10px" }}>
              <Col xs={24}>
                <LabelAndValue
                  label="Name"
                  value={
                    `${data?.paper_material?.name} ${data?.paper_grammage}` ||
                    "-"
                  }
                  status={status}
                />
              </Col>
            </Row>
          </StyledList>
        </Col>
      </Row>
    </StyledBox>
  );
}

export default JobContent;
